import { useTranslation } from 'react-i18next';
import './TeebxMethod.css';

const TeebxMethod = () => {
  const { t } = useTranslation();

  const pillars = [
    {
      minutes: t('home.method.pillars.body.minutes'),
      label: t('home.method.pillars.body.label'),
      description: t('home.method.pillars.body.description'),
      colorClass: 'tbm-pillar--body',
    },
    {
      minutes: t('home.method.pillars.swing.minutes'),
      label: t('home.method.pillars.swing.label'),
      description: t('home.method.pillars.swing.description'),
      colorClass: 'tbm-pillar--swing',
    },
    {
      minutes: t('home.method.pillars.clubs.minutes'),
      label: t('home.method.pillars.clubs.label'),
      description: t('home.method.pillars.clubs.description'),
      colorClass: 'tbm-pillar--clubs',
    },
  ];

  return (
    <div className="tbm-section">
      <div className="tbm-section-header">
        <span className="tbm-section-title">{t('home.method.title')}</span>
        <span className="tbm-section-subtitle">{t('home.method.subtitle')}</span>
      </div>

      <div className="tbm-card">
        <span className="tbm-card-label">{t('home.method.cardLabel')}</span>

        <div className="tbm-pillars">
          {pillars.map((p) => (
            <div key={p.label} className={`tbm-pillar ${p.colorClass}`}>
              <span className="tbm-pillar-minutes">{p.minutes}</span>
              <span className="tbm-pillar-label">{p.label}</span>
              <span className="tbm-pillar-desc">{p.description}</span>
            </div>
          ))}
        </div>

        <div className="tbm-card-footer">
          <span className="tbm-footer-text">
            {t('home.method.footerText')} <strong>{t('home.method.footerTextBold')}</strong> {t('home.method.footerTextSuffix')}
          </span>
          {/* <button className="tbm-footer-btn" onClick={() => {}}>
            {t('home.method.footerCta')} →
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default TeebxMethod;
